<template>
    <div class="matchdetail">
        <div @click="changeLanguage" v-if="show" class="lang">
            <tag plain type="primary">{{lang}}</tag>
        </div>
        <div class="header">
            <img :src="matchInfo.imgurl" alt/>
        </div>
        <div class="title">
            <div style="color:#333333;padding-right:15px;box-sizing:border-box;">{{matchInfo.title}}</div>
            <div class="mylike">
                <!-- <Button round size="mini" plain @click="shareinfo">分享</Button> -->
                <Button size="mini" round plain @click="likematch">{{matchInfo.favortxt}}</Button>
            </div>
        </div>
        <div class="hr"></div>
        <div class="matchinfo">
            <div>
                <div>
                    <img src="@/images/matchdetail/time.png"/>
                    <span>{{$t("message.time")}}:</span>
                </div>
                <div>{{matchInfo.starttime}}</div>
            </div>
            <div>
                <div>
                    <img src="@/images/matchdetail/time.png"/>
                    <span>{{$t("message.baoming")}}:</span>
                </div>
                <div>{{matchInfo.regstarttime}} {{$t("message.go")}} {{matchInfo.regendtime}}</div>
            </div>
            <div bindtap="gomap">
                <div>
                    <img src="@/images/matchdetail/address.png"/>
                    <span>{{$t("message.address")}}:</span>
                </div>
                <div
                        style="white-space: nowrap; overflow: hidden;  text-overflow: ellipsis;"
                >{{matchInfo.address}}
                </div>
            </div>
        </div>
        <div class="funclist">
            <div class="hr"></div>
            <div
                    class="apppadding"
                    style="height:45px;line-height:45px;background-color:#FFF;font-weight:bold;font-size:15px;border:1px solid #F2F2F2;"
            >更多功能
            </div>
            <div class="functions">
                <div @click="godesc">
                    <img src="@/images/matchdetail/rules.png" alt class="img-class"/>
                </div>
                <div @click="searchregister">
                    <img src="@/images/matchdetail/search.png" alt class="img-class"/>
                </div>
                <div @click="goalbum" v-if="havealbum">
                    <img src="@/images/matchdetail/album.png" alt class="img-class"/>
                </div>
                <div v-for="(item,index) in functions" :key="index" @click="goFunction(item)">
                    <img :src="item.icon" mode="widthFix" class="img-class"/>
                </div>
            </div>
        </div>
        <div class="footer apppadding">
            <Button
                    :type="matchInfo.regstate!==1?'':'warning'"
                    :class="matchInfo.regstate!==1?'disbutton': ''"
                    @click="showtypesheet=true"
                    size="large"
                    round
                    :disabled="matchInfo.regstate!==1"
            >{{matchInfo.btntext}}
            </Button>
        </div>

        <action-sheet
                v-model="showtypesheet"
                :actions="typeaction"
                cancel-text="取消"
                @select="onSelect"
        />

        <van-dialog v-model="show_icode" @confirm="onOk" title="请输入邀请码" show-cancel-button>
            <div style="font-size:16px;padding: 20px 12px">
                <Field v-model="icode" placeholder="请输入邀请码"/>
            </div>
        </van-dialog>

        <van-dialog
                v-model="show_album"
                title="长按查看赛事照片"
        >
            <div style="width:100%;text-align: center;">
                <img :src="albumurl" style="width:80%;height:80%;">

            </div>
        </van-dialog>

    </div>
</template>

<script>
    import "./detail.less";
    import moment from "moment";
    import {
        matchDetail,
        likematch,
        getRegisterTypeList,
        prePayorder,
        shareinfos,
        mpjsconfig,
        getfunctions,
        albumInfo
    } from "@/libs/api";
    import {Cell, CellGroup, Button, ActionSheet, Tag, Field} from "vant";
    import {
        fromatMatchTime,
        getStorage,
        formatDate,
        setStorage
    } from "@/libs/utils";
    import {shareinfo} from "@/libs/wechat";

    export default {
        name: "matchdetail",
        components: {
            Cell,
            CellGroup,
            Button,
            ActionSheet,
            Tag,
            Field
        },
        data() {
            return {
                icode: "",
                show_icode: false,
                show_album:false,
                typelist: [],
                typeaction: [],
                matchInfo: "",
                showtypesheet: false,
                havealbum: false,
                havegroup: false,
                token: "",
                urid: "",
                matchid: "",
                show: false,
                functions: [],
                lang: "中文",
                group: {}
            };
        },
        methods: {
            prePayOrder(icode) {
                let query = {
                    matchid: this.matchid,
                    typeid: this.group.id,
                    urid: this.urid
                };
                if (icode) {
                    query.invitecode = icode;
                }
                prePayorder(query).then(res => {
                    if (res.status == 200) {
                        let rgid = res.data.rgid;
                        let rrid = res.data.rrid;
                        if (this.group.registertype == 3) {
                            // 团队
                            this.$router.push({
                                name: "term",
                                params: {
                                    matchid: this.$route.params.matchid,
                                    typeid: this.group.id,
                                    rrid:rrid,
                                    rgid:rgid
                                },
                                query: {
                                    rrid,
                                    rgid
                                }
                            });
                        } else {
                            this.$router.push({
                                name: "apply",
                                params: {
                                    matchid: this.$route.params.matchid,
                                    typeid: this.group.id,
                                    rrid:rrid,
                                    rgid:rgid
                                },
                                query: {
                                    rrid,
                                    rgid
                                }
                            });
                        }
                    } else {
                        // this.$router.replace({
                        //   name: "mdetail",
                        //   params: { matchid: this.$route.params.matchid }
                        // });
                        // this.$nextTick(() => {
                        //   this.$router.go(-1);
                        // });
                    }
                });
            },
            onOk() {
                this.prePayOrder(this.icode);
                // this.$router.push({
                //   name: "apply",
                //   params: { matchid: this.$route.params.matchid, typeid: this.group.id },
                //   query: { icode: this.icode }
                // });
            },
            onSelect: function (e) {
                let matchid = this.$route.params.matchid;
                this.group = e;
                //该跳转将会放在登陆后
                if (e.name == "加入队伍") {
                    this.$router.push({
                        name: "invitemember",
                        params: {matchid: matchid}
                    });
                }
                // else if (e.registertype == 3) {
                //   //团队
                //   this.$router.push({
                //     name: "term",
                //     params: { matchid: matchid, typeid: e.id }
                //   });
                // }
                else {
                    if (e.isinvited == 1) {
                        this.show_icode = true;
                        this.group = e;
                    } else {
                        this.prePayOrder();
                        // this.$router.push({
                        //   name: "apply",
                        //   params: { matchid: matchid, typeid: e.id }
                        // });
                    }
                }
            },
            likematch() {
                likematch({
                    matchid: this.matchInfo.matchid,
                    state: this.matchInfo.favor == 1 ? 2 : 1,
                    urid: this.urid,
                    token: this.token
                }).then(res => {
                    if (res.status == 200) {
                        this.matchInfo.favortxt =
                            this.matchInfo.favor == 1 ? "收藏" : "已收藏";
                        this.matchInfo.favor = this.matchInfo.favor == 1 ? 2 : 1;
                    }
                });
            },
            matchinfo() {
                matchDetail({
                    matchid: this.matchid,
                    urid: this.urid,
                    token: this.token
                }).then(res => {
                    if (res.status == 200) {
                        if (res.data.favor == 1) {
                            res.data.favortxt = "已收藏";
                        } else {
                            res.data.favortxt = "收藏";
                        }
                        var da = new Date();
                        da.setTime(res.data.start_time * 1000);
                        res.data.starttime = formatDate(da, "Y-M-d h:m");

                        da.setTime(res.data.reg_start_time * 1000);
                        res.data.regstarttime = formatDate(da, "Y-M-d");

                        da.setTime(res.data.reg_end_time * 1000);
                        res.data.regendtime = formatDate(da, "Y-M-d");
                        this.matchInfo = fromatMatchTime(res.data);
                        //分享
                        var url = window.location.href;
                        var title = res.data.title;
                        var desc = res.data.title;
                        var imgUrl = res.data.imgurl;
                        shareinfo(url, title, desc, imgUrl);
                    }
                });
            },
            getRegister() {
                getRegisterTypeList({matchid: this.matchid}).then(res => {
                    if (res.status == 200) {
                        var typeaction = [];
                        var typelist = res.data.list;
                        typelist.forEach((item, index) => {
                            var subextra = "";
                            if (item.amount * 1 <= 0) {
                                subextra = "-报满";
                            }
                            if (item.isinvited == 1) {
                                subextra += "-邀请码";
                            }
                            //判断是否有团队
                            if (item.registertype == 3) {
                                this.havegroup = true;
                            }
                            typeaction.push({
                                id: item.typeid,
                                name: item.title,
                                subname: item.fees * 1 > 0 ? "¥" + item.fees : "免费" + subextra,
                                disabled: item.amount * 1 == 0 || item.amount * 1 < 0,
                                isinvited: item.isinvited,
                                registertype: item.registertype
                            });
                        });
                        if (this.havegroup == true) {
                            typeaction.unshift({
                                name: "加入队伍",
                                subname: "使用团队码报名"
                            });
                        }
                        this.typelist = typelist;
                        this.typeaction = typeaction;
                    }
                });
            },
            getMatchAlbum: function () {
                albumInfo({matchid: this.matchid, type: 1}).then(res => {
                    if (res.status == 200) {
                        if (res.data.id != undefined) {
                            this.albumurl = res.data.qrcode;
                            this.havealbum = true;
                        }
                    }
                });
            },
            getFunctions() {
                getfunctions({matchid: this.matchid}).then(res => {
                    if (res.success) {
                        if (res.data.length > 0) {
                            var funclist = res.data;
                            funclist.forEach((item, index) => {
                                if (item.jumptype == 2 || item.jumptype == 4) {
                                    this.functions.push(item);
                                }
                            });
                        }
                    }
                });
            },
            godesc() {
                var src = escape(this.matchInfo.intro);
                this.$router.push({name: "terms", params: {index: src}});
            },
            searchregister() {
                this.$router.push({
                    name: "search",
                    params: {matchid: this.matchid, type: "searchregister"}
                });
            },
            goalbum() {
                this.show_album = true;
            },
            goFunction(e) {
                window.location.href = e.jumpurl;
            },
            changeLanguage() {
                if (this.$i18n.locale == "en") {
                    setStorage("lang", "cn", true);
                    this.$i18n.locale = "cn";
                    this.lang = "中文";
                } else {
                    setStorage("lang", "en", true);
                    this.$i18n.locale = "en";
                    this.lang = "En";
                }
            }
        },
        mounted(options) {
            this.$nextTick(() => {
                let userinfo = getStorage("userInfo");
                console.log(userinfo);
                this.urid = userinfo.urid;
                this.token = userinfo.token;
                this.matchid = this.$route.params.matchid;
                if (this.matchid == 562) this.show = true;
                this.matchinfo();
                this.getMatchAlbum()//这是啥呀？待确认
                this.getRegister();
                this.getFunctions();
            });
        }
    };
</script>
